import React from 'react';
import { arrayOf, shape, string } from 'prop-types';

import styles from '../../styles.module.scss';
import BillingRow from '../BillingRow';

function BillingDetails({ billing }) {
  return (
    <div className={`m-left-2 m-right-2 ${styles.border}`}>
      <div className="column space-around">
        {billing.map(
          ({ text, value, hide, isTaxFree }) =>
            (value || isTaxFree) &&
            !hide && <BillingRow key={text} text={text} value={value} style={styles.clientTitle} />
        )}
      </div>
    </div>
  );
}

BillingDetails.propTypes = {
  billing: arrayOf(
    shape({
      businessEmail: string,
      businessName: string,
      businessPhone: string,
      billingType: string,
      documentId: string,
      documentType: string
    })
  )
};

export default BillingDetails;
